class ProductForm extends HTMLElement {
    constructor() {
        super();
        console.log("AB test product-form-abtest.js running for variant debug");

        this.form = this.querySelector('form');
        this.cartNotification = document.querySelector('cart-notification');

        if (this.form) {
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        // Wait for DOM fully loaded before scanning for radios
        window.addEventListener('load', () => {
            this.bindVariantRadios();
            this.createVariantPicker(); // Create the custom variant picker here
        });
    }

    // Create Variant Picker HTML
    createVariantPicker() {
        const pickerContainer = this.querySelector('.variant-picker-container'); // This is the placeholder for the picker
        if (!pickerContainer) return;

        const variantPickerHTML = `
            <div class="productView-variants halo-productOptions">
                <div class="variant-radio-group">
                    <input type="radio" id="variant1" name="product-variant" value="1" class="product-form__radio" data-price="45" checked>
                    <label for="variant1">
                        <span>1 Bottle</span>
                        <span class="price">$45.00</span>
                    </label>
                </div>
                <div class="variant-radio-group">
                    <input type="radio" id="variant2" name="product-variant" value="2" class="product-form__radio" data-price="39.5">
                    <label for="variant2">
                        <span>2 Bottles</span>
                        <span class="price">$39.50 Each (Save $30.92)</span>
                    </label>
                </div>
            </div>
        `;
        pickerContainer.innerHTML = variantPickerHTML; // Add it to the page

        // Bind the variant radios to update the price on change
        this.bindVariantRadios(); 
    }

    // Bind event listeners to the radio buttons (variant selections)
    bindVariantRadios() {
        const radios = this.querySelectorAll('input.product-form__radio');
        if (radios.length === 0) {
            console.log("No variant radios found at load");
        } else {
            radios.forEach(radio => {
                console.log(`Found variant radio: ${radio.nextElementSibling?.innerText.trim()} variant-id: ${radio.dataset.variantId}`);
                radio.addEventListener('change', () => this.onVariantChange(radio));
            });
        }
    }

    // Update price when the user selects a different variant
    onVariantChange(radio) {
        console.log(`Variant selected: ${radio.nextElementSibling?.innerText.trim()} (ID: ${radio.dataset.variantId})`);

        // Get the selected price from the radio button
        const selectedPrice = radio.dataset.price;
        const priceElement = this.querySelector('.product-price'); // Change this selector to where your price is displayed

        // Update the price on the page
        if (priceElement) {
            priceElement.innerText = `$${selectedPrice}`;
        }
    }

    // Handle the form submission (add to cart)
    onSubmitHandler(evt) {
        evt.preventDefault();
        this.cartNotification.setActiveElement(document.activeElement);

        const submitButton = this.querySelector('[type="submit"]');
        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');

        const body = JSON.stringify({
            ...JSON.parse(serializeForm(this.form)),
            sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
            .then((response) => response.json())
            .then((parsedState) => {
                this.cartNotification.renderContents(parsedState);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('disabled');
            });
    }
}

// Register the custom element
customElements.define('product-form', ProductForm);
